module.exports = __webpack_public_path__ + "img/Drop.9f35fc6e.png";